import LoadingSpinner from '@components/common/loading/LoadingSpinner';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useUserInfoQuery } from '@apis/query/user';
import { UserType } from '@asset/enum/UserEnum';
import { MY_CLASS_MAIN_URL_PREFIX } from 'routes/common';
import { getLoginPageUrlObject } from 'routes/account';
import { getMyStudyRecordsPageUrlObject } from 'routes/dashboard';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const index = () => {
  const {
    data: user
  } = useUserInfoQuery();
  const router = useRouter();
  useEffect(() => {
    if (user) {
      if (user.type === UserType.TEACHER) router.push(MY_CLASS_MAIN_URL_PREFIX);else if (user.type === UserType.STUDENT) router.push('/dashboard');else if (user.type === UserType.PARENT) router.push(getMyStudyRecordsPageUrlObject({
        userType: UserType.PARENT
      }));
    } else if (user === null) {
      router.push(getLoginPageUrlObject({}));
    }
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default index;